import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { MainComponent } from './layout/main/main.component';
import { PageLoaderComponent } from './shared/component/page-loader/page-loader.component';
import { TopLoaderComponent } from './shared/component/top-loader/top-loader.component';
import { SharedModule } from './shared/shared.module';
import { HelperService } from './shared/service/helper.service';
import { MenuItems } from './shared/helper/menu-items/menu-items';
import { ToastrModule } from 'ngx-toastr';
import { WINDOW_PROVIDERS } from './window.providers';

import { StoreModule } from '@ngrx/store';
import { AppHttpInterceptor } from './http.interceptor';
import { MainModule } from './layout/main/main.module';
import { EffectsModule } from '@ngrx/effects';
import { iotDeviceManagementPortalAppReducer } from './store/iotDeviceManagementPortalApp.reducer';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { MaskComponent } from './shared/component/mask/mask.component';
import { PageHeaderService } from './shared/service/page-header/page-header.service';
import { CookieService } from 'ngx-cookie-service';
import { ForbiddenComponent } from './view/error/forbidden/forbidden.component';
import { GlobalErrorHandlerService } from './shared/service/error-service/global-error-handler.service';
import { MonitoringService } from './shared/service/error-service/monitoring.service';
import { MomentDatePipe } from './shared/pipe/moment-date.pipe';
import { getApiUrl } from './utilities';
import { DatePipe } from '@angular/common';
import { UserEffects } from './store/user/user.effects';
import { HomeEffects } from './store/home/home.effects';
import { AppEffects } from './store/app/effects';
import { MainEffects } from './store/main/main.effects';
import { JWTTokenService } from './shared/service/jwt-token-service';
import { LoginComponent } from './view/login/login.component';
import { LogoutComponent } from './view/logout/logout.component';
import { DeviceEffects } from './store/device/device.effects';
import { UserConfigurationEffects } from './store/user-configuration/user-configuration.effects';
import { FilterDeviceTypeEffects } from './store/filter/device-type/device-type.effects';
import { DeviceLastMessageEffects } from './store/device-last-message/device-last-message.effects';
import { FirmwareManagerEffects } from './store/firmware-manager/firmware-manager.effects';
import {UserManagementEffects} from "./store/user-management/user-management.effects";
import {DeviceCommandScheduleEffects} from "./store/device-command-schedule/device-command-schedule.effects";
import {DeviceParametersEffects} from "./store/device-parameters/device-parameters.effects";
import { DeviceDashboardEffects } from './store/device-dashboard/device-dashboard.effects';

@NgModule({
  declarations: [
    AppComponent,
    MainComponent,
    PageLoaderComponent,
    TopLoaderComponent,
    MaskComponent,
    ForbiddenComponent,
    LoginComponent,
    LogoutComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
    ToastrModule.forRoot({
      maxOpened: 8,
      preventDuplicates: true,
      countDuplicates: false,
    }),
    EffectsModule.forRoot([
      UserEffects,
      UserConfigurationEffects,
      HomeEffects,
      AppEffects,
      MainEffects,
      DeviceEffects,
      DeviceDashboardEffects,
      DeviceLastMessageEffects,
      DeviceParametersEffects,
      DeviceCommandScheduleEffects,
      FilterDeviceTypeEffects,
      FirmwareManagerEffects,
      UserManagementEffects,
    ]),
    StoreModule.forRoot(iotDeviceManagementPortalAppReducer),
    StoreDevtoolsModule.instrument({
      maxAge: 10,
    }),
    HttpClientModule,
    MainModule,
    ServiceWorkerModule.register('./ngsw-worker.js', { enabled: environment.production }),
  ],
  schemas: [],
  providers: [
    MenuItems,
    HelperService,
    WINDOW_PROVIDERS,
    { provide: HTTP_INTERCEPTORS, useClass: AppHttpInterceptor, multi: true },
    PageHeaderService,
    CookieService,
    JWTTokenService,
    MonitoringService,
    { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
    { provide: HTTP_INTERCEPTORS, useClass: AppHttpInterceptor, multi: true },
    MomentDatePipe,
    DatePipe,
    {
      provide: 'API_BASE_URL',
      useFactory: getApiUrl,
    },
  ],
  bootstrap: [AppComponent],
  exports: [PageLoaderComponent],
})
export class AppModule {}
